import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import {
  AppShell,
  Burger,
  Group,
  Title,
  NavLink as MantineNavLink,
  ScrollArea,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import {
  IconChartBar,
  IconBrain,
  IconCalendarStats,
  IconHome,
  IconChartDots,
  IconCalendarEvent,
  IconUserCheck,
  IconStairs,
  IconAdjustments,
  IconCash,
} from '@tabler/icons-react';

// Pages
import HomePage from './pages/HomePage';
import PredictionsPage from './pages/PredictionsPage';
import DesignedShiftsPage from './pages/DesignedShiftsPage';
import AssignedShiftsPage from './pages/AssignedShiftsPage';
import ScheduleStepsPage from './pages/ScheduleStepsPage';
import ModelsPage from './pages/ModelsPage';
import ActualVsExpectedPage from './pages/ActualVsExpectedPage';
import SupplyCurveConfig from './pages/SupplyCurveConfig';
import PayrollPreviewPage from './pages/PayrollPreviewPage';

// Navigation items - ordered by workflow
const navItems = [
  { path: '/predictions', label: 'Predictions', icon: IconCalendarStats },
  { path: '/designed-shifts', label: 'Shifts Design', icon: IconCalendarEvent },
  { path: '/assigned-shifts', label: 'Assigned Shifts', icon: IconUserCheck },
  { path: '/schedule-steps', label: 'Schedule Steps', icon: IconStairs },
  { path: '/supply-curve', label: 'Supply Curve Config', icon: IconAdjustments },
  { path: '/payroll', label: 'Payroll Preview', icon: IconCash },
  // TODO: Add Employee Preferences page
  { path: '/models', label: 'Models & Coefficients', icon: IconBrain },
  { path: '/actual-vs-expected', label: 'Actual vs Expected', icon: IconChartDots },
  { path: '/', label: 'Model Summary', icon: IconHome },
];

function App() {
  const [opened, { toggle }] = useDisclosure();
  const location = useLocation();

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{ width: 250, breakpoint: 'sm', collapsed: { mobile: !opened } }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md">
          <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
          <IconChartBar size={28} color="#228be6" />
          <Title order={3}>Jetana Games</Title>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <AppShell.Section grow component={ScrollArea}>
          {navItems.map((item) => (
            <MantineNavLink
              key={item.path}
              component={NavLink}
              to={item.path}
              label={item.label}
              leftSection={<item.icon size={20} />}
              active={location.pathname === item.path}
              mb={4}
            />
          ))}
        </AppShell.Section>
      </AppShell.Navbar>

      <AppShell.Main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/predictions" element={<PredictionsPage />} />
          <Route path="/designed-shifts" element={<DesignedShiftsPage />} />
          <Route path="/assigned-shifts" element={<AssignedShiftsPage />} />
          <Route path="/schedule-steps" element={<ScheduleStepsPage />} />
          <Route path="/supply-curve" element={<SupplyCurveConfig />} />
          <Route path="/payroll" element={<PayrollPreviewPage />} />
          <Route path="/actual-vs-expected" element={<ActualVsExpectedPage />} />
          <Route path="/models" element={<ModelsPage />} />
        </Routes>
      </AppShell.Main>
    </AppShell>
  );
}

export default App;
